<template>
  <div class="list_accounts">
    <div class="list-state-container">
      <div class="empty-icon">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="#7481A6"/>
        </svg>
      </div>
      <span class="empty-message">No artist accounts found.</span>
      <button 
        type="button" 
        class="c2a_btn sign_up fizz-effect create-btn" 
        v-ripple 
        @click="$emit('create-artist')"
      >
        Create new artist
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyArtistsList'
}
</script>

<style lang="scss" scoped>
.list-state-container {
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
  background-color: #0C1324;
  border: 1px solid #282C47;
  border-radius: 10px;
  margin-bottom: 15px;
  
  .empty-icon {
    margin-bottom: 20px;
  }
  
  .empty-message {
    font-size: 16px;
    color: #7481A6;
    margin-bottom: 25px;
  }
  
  .create-btn {
    margin-top: 10px;
  }
}

.list_accounts {
  max-height: 330px;
  overflow-y: auto;
  margin-bottom: 15px;
}

.c2a_btn {
  width: auto;
  min-width: 120px;
  height: 45px;
  border-radius: 50px;
  border: none;
  color: white;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  
  &.sign_up {
    background: rgba(0, 200, 100, 0.9) !important;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    
    &:hover {
      background: rgba(0, 210, 110, 0.95) !important;
    }
  }
  
  &.create-btn {
    margin-top: 20px;
    max-width: 200px;
  }
}
</style>
